// สถานะ Product Set: 1 Draft (ข้อมูลเดิมคือ ready to link), 2 Approved/Linked, 3 Pending Approve
export const RENDER_STATUS_PRODUCT_WARRANTY_SET = (key) => {
  switch (key) {
    case '1':
      return {
        label: 'Draft',
        bg: '#4b1e78',
      };
    case '2':
      return {
        label: 'Approved',
        bg: '#008000',
      };
    case '3':
      return {
        label: 'Pending Approve',
        bg: '#ef6c00',
      };
    default:
      break;
  }
};
